import { route } from 'preact-router';

import { getHomeURL } from '../../helpers';

// eslint-disable-next-line import/prefer-default-export
export const authRedirect = (path) => {
  try {
    if (path) {
      route(`${path}${path === '/talk-schedule' ? window.location.search : ''}`, true);
    } else if (localStorage.getItem('returningUser')) {
      route('/login', true);
    } else {
      route(getHomeURL(), true);
    }
  } catch (err) {
    console.warn('Local storage is not available.');
    route(getHomeURL(), true);
  }
};
